import styles from '../index.less';

const EmptyData = ({ text = '暂无数据' }) => {
  return (
    <div className={styles['empty-data']}>
      <p className={styles['empty-text']}>{text}</p>
    </div>
  );
};
export default EmptyData;
